export default class BlockFullTeam {
  constructor(element) {
    this.element = element

    this.currentGroup = false
    this.groupsPosition = 0

    this.items = element.querySelectorAll('.js-team-item')
    this.btPrev = element.querySelector('.js-fullTeam-prev')
    this.btNext = element.querySelector('.js-fullTeam-next')
    this.groups = element.querySelector('.js-fullTeam-groups')
    this.groupsContainer = element.querySelector(
      '.js-fullTeam-groups-container',
    )
    this.buttons = element.querySelectorAll('.js-fullTeam-button')

    this.buttons.forEach((button) => {
      const g = button.dataset.id
      button.addEventListener('click', () => {
        if (g !== this.currentGroup) {
          this.currentGroup = g
        } else {
          this.currentGroup = false
        }
        this.filterByGroup()
      })
    })

    this.groupsContainer.addEventListener('scroll', () => {
      if (this.groupsContainer.scrollLeft === 0) {
        this.btPrev.classList.remove('js-active')
      } else {
        this.btPrev.classList.add('js-active')
      }

      const maxScroll = this.groupsContainer.scrollWidth - this.groupsContainer.getBoundingClientRect().width
      if (this.groupsContainer.scrollLeft + 1 >= maxScroll) {
        this.btNext.classList.remove('js-active')
      } else {
        this.btNext.classList.add('js-active')
      }
    }, { passive: true })

    this.btPrev.addEventListener('click', () => {
      this.moveGroups(1)
    })
    this.btNext.addEventListener('click', () => {
      this.moveGroups(-1)
    })

    this.filterByGroup()
    this.moveGroups(0)
    element.classList.add('js-fullTeam--initialized')

    window.addEventListener('resize', () => {
      requestAnimationFrame(()=>{
        this.moveGroups(0)
      })
    })
  }

  moveGroups(direction) {
    this.groupsContainer.scrollWidth - wrapWidth
    const wrapWidth = this.groupsContainer.getBoundingClientRect().width

    if (direction === 1) {
      this.groupsContainer.scrollTo(0, 0)
    } else if (direction === -1) {
      this.groupsContainer.scrollTo(this.groupsContainer.scrollWidth - wrapWidth, 0)
    }
  }

  filterByGroup() {
    this.buttons.forEach((button) => {
      if (button.dataset.id === this.currentGroup) {
        button.classList.add('js-active')
      } else {
        button.classList.remove('js-active')
      }
    })

    let index = 0
    this.items.forEach((item) => {
      if (!this.currentGroup) {
        item.classList.remove('js-team-item--inactive')
        index++
      } else {
        if (item.dataset.groups) {
          const groups = item.dataset.groups.split('+')
          if (groups.indexOf(this.currentGroup) !== -1) {
            item.classList.remove('js-team-item--inactive')
            index++
          } else {
            item.classList.add('js-team-item--inactive')
          }
        } else {
          item.classList.add('js-team-item--inactive')
        }
      }

      if ((index - 1) % 3 === 2) {
        item.classList.add('nomargin')
      } else {
        item.classList.remove('nomargin')
      }
    })
  }
}
